<template>
        <div>
        <BoxTrackListEmptyCard v-if="!trackListLoading && (!trackList ||trackList.length==0)"/>
        <div v-else class="full">
            <table ref="table" class="track-table" :class="{ 'is-sorting': viewState.isSorting || isUpdating }">
                <thead>
                    <tr>
                        <th class="text-right">
                            <i
                                :class="{
                                    'far': true,
                                    'fa-square': selectedFileData.length === 0,
                                    'fa-check-square': selectedFileData.length === tracks.length,
                                    'fa-minus-square': selectedFileData.length < tracks.length
                                }"
                                @click.prevent="toggleSelection()"
                                ></i>
                        </th>
                        <th v-if="isPlaylist">#</th>
                        <th v-for="header in listHeaders" :key="header.key" :class="`header-${header.key}`">
                            <a
                                v-if="currentBox && currentBox.type !== 'PLAYLIST' && header.sortable"
                                href="#"
                                :class="`sort ${sort.field === header.key ? 'is-active' : ''}`"
                                @click.prevent="sortBy(header.key, header.comparisonKey)"
                                :disabled="isUpdating">
                                <span v-text="header.label"></span>
                                <div class="sort-icons" v-if="header.key !== sort.field || !viewState.isSorting">
                                    <i class="fas fa-chevron-up" :style="`color: ${sort.field === header.key && sort.ascending ? '#000' : '#aaa'};`"></i>
                                    <i class="fas fa-chevron-down" :style="`color: ${sort.field === header.key && !sort.ascending ? '#000' : '#aaa'};`"></i>
                                </div>

                                <i v-if="header.key === sort.field && viewState.isSorting" class="fas fa-sync-alt"></i>
                            </a>
                            <span v-else v-text="header.label"></span>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <!--
                <tbody v-if="trackListLoading">
                    <tr>
                        <td :colspan="listHeaders.length + 2 + (isPlaylist?1:0)">
                            <WaitingBlock/>
                        </td>
                    </tr>
                </tbody>
                -->
                <tbody :style={opacity:!trackListLoading} ref="tableBody" v-on:dragover="onDragOver" v-on:drop="onDrop">
                    <tr :class="{shiftable:shiftSelection.startIndex !=null && shiftSelection.startIndex == index, selected:selectedFiles.tracks[currentBox && (currentBox.type === 'PLAYLIST' ? track.linkData.recordUid : track.uid)] !== undefined}"
                        v-for="(track, index) in tracks"
                        :key="`detail-track-${index}`"
                        :draggable="!trackSearch"
                        v-on:drag="onDrag"
                        v-on:dragstart="onDragStart($event, track)"
                        v-on:dragend="onDragEnd"
                    >
                        <td class="text-right" width="45px">
                            <span>
                              <PlayButton class="play-button mr-2" :track="track"></PlayButton>
<!--                               <span v-if="!track.isComplete" v-tooltip="{ data: 'Quick upload track'}">-->
                               <span v-if="!track.isComplete" >
                                 <i  class="fas fa-exclamation-triangle" style="color: #5bc8fe; margin-right: 5px"></i>
                              </span>
                               <span v-if="track.isComplete" style="margin-left: 19px">&nbsp;</span>
                              <i
                                @click.prevent="toggleTrack(track, $event, index)"
                                :class="['far', selectedFiles.tracks[currentBox && (currentBox.type === 'PLAYLIST' ? track.linkData.recordUid : track.uid)] === undefined ? 'fa-square':'fa-check-square']"
                              ></i>

                            </span>
                        </td>
                        <td v-if="currentBox && currentBox.type === 'PLAYLIST'">{{ track._position }}</td>
                        <template v-for="header in listHeaders">
                            <td :key="header.key" :class="`td-${header.size}`">
                                <template v-if="header.key === 'duration'">
                                    {{ track._duration.min }}:{{ track._duration.sec }}
                                </template>
                                <template v-else-if="header.key === '_date'">
                                    {{ track._date }}
                                </template>
                                <template v-else-if="header.key === 'isExplicit'">{{ track.isExplicit ? 'True' : '' }}</template>
                                <template v-else-if="header.key === '_rotationDate'">
                                    {{ track._rotationDate }}
                                </template>
                                <template v-else-if="typeof track[header.key] === 'object' && header.key !== 'tags' && header.key !== 'charts'" >
                                    {{ track[header.key] ? track[header.key].map(value => value.name).join(', ') : '' }}
                                </template>
                                <template v-else-if="typeof track[header.key] === 'object' && header.key === 'tags'" >
                                  <div style="display: flex;">
                                    <div v-for="tag in track[header.key]" >
                                      <div class="tag" :style="{backgroundColor: '#'+ tag.backColor , color:'#'+ tag.fontColor }"> {{tag.name}}</div>
                                    </div>
                                  </div>

                                </template>
                              <template v-else-if="typeof track[header.key] === 'object' && header.key === 'charts'" >
                                <div style="display: flex;">
                                  <div v-for="chart in track[header.key]" >
                                    <div class="chart" >
                                        <span v-if="typeof chart.position == 'number'">
                                            <span class="flag-icon flag-icon-squared" v-if="loadCountiesList.filter(country => country.id === chart.countryId)"
                                                  :class="['flag-icon-' + loadCountiesList.filter(country => country.id === chart.countryId)[0].code.toLowerCase()]"
                                                  v-tooltip="{data:' ' + loadCountiesList.filter(country => country.id === chart.countryId)[0].name +
                                                ', Position: ' + chart.position + ', Weeks: '+ chart.weeks + ', Entry: '+ moment(chart.entry).format('DD/MM/YYYY')}"
                                            ></span>&nbsp;&nbsp;
                                            </span>
                                            <span v-if="!(typeof chart.position == 'number')"><span class="flag-icon flag-icon-squared" v-if="loadCountiesList.filter(country => country.id === chart.countryId)"
                                                   :class="['flag-icon-' + loadCountiesList.filter(country => country.id === chart.countryId)[0].code.toLowerCase()]"
                                                    v-tooltip="{data:' ' + loadCountiesList.filter(country => country.id === chart.countryId)[0].name +
                                                ', Charted: No' + ', Entry: '+ moment(chart.entry).format('DD/MM/YYYY')}"
                                                        ></span>&nbsp;&nbsp;
                                        </span>

                                    </div>
                                  </div>
                                </div>

                              </template>
<!--                                <template v-else-if="header.key === 'description'">-->
<!--                                  <span class="description" v-tooltip="{data: track[header.key], arrowPosition: 'top', isDisabled: track[header.key].length <=10 }">-->
<!--                                    {{ track[header.key] }}-->
<!--                                  </span>-->
<!--                                </template>-->
                                <template v-else>
                                    {{ track[header.key] }}
                                </template>
                            </td>
                        </template>
                      <td width="32">
                        <b-dropdown no-caret>
                          <template slot="button-content">
                            <i class="fas fa-ellipsis-v"></i>
                          </template>
                                <b-dropdown-item @click="handleSettings(track)">Settings...</b-dropdown-item>
                                <b-dropdown-item v-on:click="moveFiles([track])">Move</b-dropdown-item>
                                <b-dropdown-item v-on:click="similarTracks([track])">Similar song</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item v-on:click="removeTrack(track)">Delete</b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                </tbody>

            </table>
              <div  class="table-footer" v-if="hasFixedFooter">
                <div class="table-footer-left">
                  <a href="#" class="table-footer-button" v-on:click.prevent="removeAllSelectedTracks">
                    <i class="fas fa-times fas-xl"></i>
                  </a>

                  <span class="table-footer-text">
                                        <div style="display:inline;"
                                             :draggable="!trackSearch"
                                             v-on:drag="onDrag"
                                             v-on:dragstart="onDragStart($event, track)"
                                             v-on:dragend="onDragEnd"
                                        >
                                        <span class="table-footer-count">{{ selectedFileData.length }}</span>
                                        tracks selected
                                    </div>
                                    </span>
                </div>

                <div class="table-footer-right">
                  <a href="#" class="table-footer-button" @click.prevent="editTracksMeta">
                    <i class="fas fa-pen fas-l" v-tooltip="{data: 'Full edit', arrowPosition: 'right'}"></i>
                  </a>

                  <a href="#" class="table-footer-button" @click.prevent="editTracksMix">
                    <i class="fas fa-random fas-l" v-tooltip="{data: 'Edit mix point', arrowPosition: 'right'}"></i>
                  </a>
                  <span v-if="uploadLocked" >
                                        <a href="#" class="table-footer-button cursor-not-allowed"
                                           v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">
                                        <i  :class="['fas', 'fa-file-export','fas-l']"></i>
                                        </a>
                                        <a href="#" class="table-footer-button cursor-not-allowed"
                                           v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Remove files' , arrowPosition: 'right'}">
                                          <i :class="['fas', 'fa-trash','fas-l']"></i>
                                        </a>
                                     </span>

                  <span v-if="!uploadLocked">
                                    <a href="#" class="table-footer-button" @click.prevent="moveFiles('selected')">
                                        <i class="fas fa-file-export fas-l" v-tooltip="{data: 'Move files', arrowPosition: 'right'}"></i>
                                    </a>

                                    <a href="#" class="table-footer-button" @click.prevent="removeTrack('selected')">
                                        <i class="fas fa-trash fas-l" v-tooltip="{data: 'Remove files', arrowPosition: 'right'}"></i>
                                    </a>
                                    </span>
                </div>
              </div>
        </div>
            <SelectorBoxes
                v-show="false"
                ref="modalBoxes"
                :stationUid="stationUid"
                :noModalEdit="true"
                v-on:newValue="linkToBoxes"
            />
          <SelectorSimilarTracks
              v-show="false"
              ref="modalSimilarTracks"
              :stationUid="stationUid"
              :boxUid="boxUid"
              :trackUid="trackUid"
              :noModalEdit="true"
              v-on:refreshData="refreshData"
          />
            <!-- <MoveTracks ref="moveTracks" v-show="false" v-on:removeTracks="removeFilesFromList"/> -->
        </div>
</template>

<script>
    import { HTTP } from "@/utils/http";
    import store from '@/store/index.js';
    import Apis from "@/apis/index"
    import Enums from '@/apis/_enums';
    import Translations from '@/store/translations';
    import WaitingBlock from '@/components/common/WaitingBlock.vue';
    import ItemListCard from '@/components/common/PlannerItemListCard.vue';
    //import MoveTracks from "@/components/common/MoveTracks.vue";
    import {mapActions, mapGetters, mapState} from 'vuex';
    import EventBus from "@/eventbus";
    import BoxTrackListEmptyCard from './BoxTrackListEmptyCard';
    import PlayButton from "@/components/common/PlayButton.vue";
    import SelectorBoxes from "@/components/Library/SelectorBoxes.vue";
    import SelectorSimilarTracks from "@/components/Library/SelectorSimilarTracks.vue";
    import Constants from "@/store/constants";
    import moment from "moment";


    export default {
        name: "BoxDetails",
        store,
        components: { WaitingBlock, ItemListCard,
            BoxTrackListEmptyCard,
            SelectorSimilarTracks,
            //MoveTracks,
            SelectorBoxes, PlayButton
        },
        async mounted() {
            this.stationUid = this.$route.params.stationUid;
            this.boxUid = this.$route.params.boxUid;
            if(this.$route.params.boxUid) {
                await this.reloadTracks(1);
            }
            EventBus.$on('onBoxTrackRecordsRemoved',this.onBoxTrackRecordsRemoved);
            EventBus.$on('onBoxTrackMoved',this.reloadTracks);
            EventBus.$on("onTracksSearch",this.reloadTracks);
              EventBus.$on("isStationLockedBus", this.getLockData);
            if (this.uploadLocked === null ){
              this.uploadLocked = this.uploadLockedStore();
            }
            this.$store.dispatch("tracks/loadCountiesList")
        },
        destroyed() {
            this.$store.commit('Boxes/CLEAN_STATE')
            EventBus.$off('onBoxTrackRecordsRemoved',this.onBoxTrackRecordsRemoved);
            EventBus.$off('onBoxTrackMoved',this.reloadTracks);
            EventBus.$off("onTracksSearch",this.reloadTracks);
            EventBus.$off("isStationLockedBus", this.getLockData);
        },
        watch: {
            'currentBox': {
                handler: function (value) {
                    if (value && value.type === 'PLAYLIST') {
                        this.sort.field = '_position'
                    } else {
                        this.sort.field = 'artist'
                    }
                    this.sort.ascending = true
                },
                deep: true,
                immediate: true
            },
            // 'trackList': {
            //     handler: function (value) {
            //         if(!!value) {
            //             let begin = ((this.currentPagination.page - 1) * this.currentPagination.pageSize);
            //             let end = begin + this.currentPagination.pageSize
            //             const totalCount = value.length;
            //             this.currentPagination = ({
            //                 count: totalCount,
            //                 pageCount: Math.ceil(+(totalCount / this.currentPagination.pageSize)),
            //                 pageSize: this.currentPagination.pageSize,
            //                 page: this.currentPagination.page,
            //                 currentOffset: [begin, end]
            //             })
            //         }
            //     },
            //     deep: true,
            //     immediate: true
            // },
            // 'currentPagination.page': {
            //     handler: function (value) {
            //         if(!!value && !!this.trackList.length){
            //             const totalCount = this.trackList.length;
            //             const { pageSize, page, pageCount } = this.currentPagination;
            //             let begin = ((page - 1) * pageSize);
            //             let end = begin + pageSize
            //             this.currentPagination = ({
            //                 count: totalCount,
            //                 pageCount: Math.ceil(+(totalCount / pageSize)),
            //                 pageSize: pageSize,
            //                 page: page > pageCount ? pageCount : page,
            //                 currentOffset: [begin, end]
            //             })
            //         }
            //     },
            // },
            'trackSearch': {
                handler: function (value) {
                    const totalCount = !!value ? this.searchResult.length : this.trackList.length;
                    const { pageSize, page, pageCount } = this.currentPagination;
                    let begin = ((page - 1) * pageSize);
                    let end = begin + pageSize
                    this.currentPagination = ({
                        count: !!value ? this.searchResult.length : this.trackList.length,
                        pageCount: Math.ceil(+(totalCount / pageSize)),
                        pageSize: pageSize,
                        page: page > pageCount ? pageCount : page,
                        currentOffset: [begin, end]
                    })
                },
            },
            '$route': function (to, from) {
                //reset
                this.removeAllSelectedTracks()
                this.stationUid = this.$route.params.stationUid;
                this.boxUid = this.$route.params.boxUid;
                this.reloadTracks();
            },
        },
        computed: {
            ...mapActions('tracks', ["loadCountiesList"]),
            ...mapState({
                isLoadingBox: state => state.loadingStates.isLoadingBox,
                currentBox: state => state.currentBox,
                trackList: state => state.Boxes.trackList,
                pagination: state => state.Boxes.pagination,
                trackListLoading: state => state.Boxes.trackListLoading,
                trackSearch: state => state.Boxes.trackSearch,
                loadCountiesList(state){return  state.tracks.countries},
            }),
            isPlaylist(){return this.currentBox && this.currentBox.type === 'PLAYLIST'},
            Translations: () => Translations,
            tracks () {
                this.searchResult = this.$store.getters['Boxes/search'](this.trackSearch)
                const result = this.searchResult.length >= 0 ? this.searchResult : this.trackList ;
              if (result === null){
                return []
              }else{
                console.log(this.listHeaders)
                console.log((result || [])
                    //.slice(this.currentPagination.currentOffset[0], this.currentPagination.currentOffset[1])
                    .map((track) => ({
                      ...track,
                      _position: track.linkData.position,
                      _icon: this.trackTypes[track.typeID],
                      _duration: this.getMinSec(track.duration),
                      _rotationDate : new Date(track.linkData.creationDate).toLocaleDateString('fr-BE'),
                      _date: new Date(track.publicationDate).toLocaleDateString('fr-BE')
                    })))
                return (result || [])
                    //.slice(this.currentPagination.currentOffset[0], this.currentPagination.currentOffset[1])
                    .map((track) => ({
                      ...track,
                      _position: track.linkData.position,
                      _icon: this.trackTypes[track.typeID],
                      _duration: this.getMinSec(track.duration),
                      _rotationDate : new Date(track.linkData.creationDate).toLocaleDateString('fr-BE'),
                      _date: new Date(track.publicationDate).toLocaleDateString('fr-BE')
                    }))
                // .sort((a, b) => {
                //     const sortField = this.sort.comparisonKey ? this.sort.comparisonKey : this.sort.field

                //     const fieldA = typeof a[sortField] === 'string' ? a[sortField].toUpperCase() : a[sortField]
                //     const fieldB = typeof b[sortField] === 'string' ? b[sortField].toUpperCase() : b[sortField]

                //     let comparison = 0
                //     if (fieldA > fieldB) {
                //         comparison = 1
                //     } else if (fieldA < fieldB) {
                //         comparison = -1
                //     }
                //     return this.sort.ascending ? comparison : comparison * -1
                // });
              }

            },
            trackTypes() { return Enums.TrackTypes; },
            selectedFileData: function() {
              return {
                length: Object.keys(this.selectedFiles.tracks).length,
                tracks: Object.values(this.selectedFiles.tracks)
                // trackUids: Object.keys(this.selectedFiles.tracks) || []
              };
            },
            hasFixedFooter() {
              return this.selectedFileData.length > 0
            },
            listHeaders(){
                let headers = [];
                headers.push({ label: 'Artist', key: 'artist', sortable: true, size: null });
                headers.push({ label: 'Title', key: 'title', sortable: true, size: null });
                headers.push({ label: "Explicit", key: "isExplicit", sortable: true, size: "m" });
                headers.push({ label: "Styles", key: "styles", sortable: false, size: "s" });
                headers.push({ label: 'Language', key: 'languages', sortable: true, size: 's' });
                // headers.push({ label: "Label", key: "label", sortable: true, size: "xl" });
                headers.push({ label: "BPM", key: "bpm", sortable: true, size: "m" });
                headers.push({ label: "Year", key: "year", sortable: true, size: "m" });
                headers.push({ label: "Mood", key: "mood", sortable: true, size: "auto", specificClass:"mlt" });
                headers.push({ label: "Energy", key: "energy", sortable: true, size: "auto", specificClass:"mlt"});
                headers.push({ label: "Gender", key: "genderId", sortable: true, size: "auto", specificClass:"mlt" });

                headers.push({ label: "Duration", key: "duration", sortable: true, size: "m" });
                if (this.currentBox && this.currentBox.type!=="SMARTBOX")
                    headers.push({ label: 'Rotation Date', key: '_rotationDate', sortable: true, size: null, comparisonKey: 'rotationDate' });
                headers.push({ label: 'Info', key: 'description', sortable: true, size: 's' });
                headers.push({ label: "Instruments", key: "instruments", sortable: true, size: "xl" });
                headers.push({ label: " % Vocal-Instruments", key: "vocalInstruments", sortable: true, size: "xl" });
                headers.push({ label: "Charts", key: "charts", sortable: true, size: "l" });
                headers.push({ label: "Tags", key: "tags", sortable: true, size: "xl" });
                return headers;

        // return [
        //     {
        //       label: "Info",
        //       key: "description",
        //       sortable: true,
        //       size: "xl"
        //     },
        //     { label: "Gender", key: "genderId", sortable: true, size: "auto", specificClass:"mlt" },
        //     { label: "Explicit", key: "isExplicit", sortable: true, size: "m" },
        //     { label: "Duration", key: "duration", sortable: true, size: "m" },
        //     { label: "Date", key: "publicationDate", sortable: true, size: "l" }
        // ]

            }
            ,
        }, getLockData(value) {
        console.log(value)
        this.uploadLocked = value;
      },
        data() {
            return {
                uploadLocked: null,
                moment,
                stationLockDescriptionShort: Constants.stationLockedLabelShort,
                stationLockDescription: Constants.stationLockedLabel,
                searchResult: '',
                currentPagination: {
                    count: '',
                    pageCount: '',
                    pageSize: 100,
                    page: 1,
                    currentOffset: [0, 100]
                },
                viewState: {
                    isLoadingBoxTracks: false,
                    isSorting: false
                },
                shiftSelection:
                {
                    startIndex:null, endIndex:null, isSelected:false
                },
                trackToPlay: null, // CREATED TO COMPILE
                playerIsPaused: false, // CREATED TO COMPILE,
                isDragging: false,
                isUpdating: false,
                currentDrag: null,
                $lineIndex: null,
                $items: [],
                toggles: [],
                index: null,
                stationUid: null,
                boxUid: null,
                trackUid: null,
                sort: {
                  field: null,
                  comparisonKey: null,
                  ascending: true
                },

                selectedFiles: {
                  tracks: {},
                  updateTime: new Date()
                },
            }
        },
        methods: {
          ...mapState('tracks', ['uploadLockedStore']),
          getLockData(value) {
            console.log(value)
            this.uploadLocked = value;
          },
          refreshData(value){
            if (value){
               this.refreshBoxStats(this.$route.params.stationUid,this.$route.params.boxUid)
               this.reloadTracks();
            }
          },
            //********************************************************************/
            // Fwi
            //********************************************************************/
            async linkToBoxes(type, targetBoxes)
            {
                for(var idx in targetBoxes)
                {
                    let box = targetBoxes[idx];
                    console.log("Data : ",box, Object.keys(this.selectedFiles.tracks), box.uid, box.stationUid);
                    await this.$store.dispatch("Boxes/linkMultipleTrack",
                    {
                        stationUid: box.stationUid,
                        boxUid: box.uid,
                        trackUids:Object.keys(this.selectedFiles.tracks)
                    })
                    await this.refreshBoxStats(box.stationUid,box.uid)
                }

                await this.refreshBoxStats(this.$route.params.stationUid,this.$route.params.boxUid)
                await this.reloadTracks();
            },
            async onBoxTrackRecordsRemoved(){
                console.log("BoxDetails : onBoxTrackRecordsRemoved");
                this.removeAllSelectedTracks();
                await this.reloadTracks();
                this.refreshBoxStats(this.$route.params.stationUid,this.$route.params.boxUid)
            },

            async refreshBoxStats(stationUid, boxUid){
                if (stationUid != this.$route.params.stationUid) return;
                await this.$store.dispatch("refreshBoxStats",
                {
                    stationUid: this.$route.params.stationUid,
                    boxUid: this.$route.params.boxUid,
                })
            },
            async reloadTracks(page){
                console.log("Reload Tracks",page);
                // Fire and Forget
                await this.$store.dispatch('Boxes/getTrackList', {
                    stationUid: this.$route.params.stationUid,
                    boxUid: this.$route.params.boxUid,
                    page:page || (this.pagination || {page:1}).page || 1,
                    pageSize: (this.pagination || { pageSize: 100 }).pageSize,
                    sortField:this.sort.field,
                    sortAscending : this.sort.ascending,
                    trackSearch: null
                })
                this.selectedFiles.tracks = {}
            },
            //********************************************************************/

            removeTrack(track) {
                if (track === 'selected') {
                    const files = Object.values(this.selectedFiles.tracks)
                    EventBus.$emit('onBoxTrackDelete', files, this.currentBox);
                } else {
                    EventBus.$emit('onBoxTrackDelete', track, this.currentBox);
                }
            },
            // DRAG EVENTS
            onDragStart(e, track) {
                e.dataTransfer.setData("text/html", "drag");
                const tracks = [];
                const $ghost = document.body.querySelector("#drag-ghost");
                console.log(this.selectedFileData);
                if (this.selectedFileData.length >1)
                    //(this.selectedFiles.tracks[track.uid] != null &&
                    //    this.selectedFileData.length > 1) ||
                    //track === "selection")
                {
                    $ghost.innerHTML = `${this.selectedFileData.length} files selected`;
                    Object.keys(this.selectedFileData.tracks).map(key => {
                        tracks.push(this.selectedFileData.tracks[key]);
                    });
                } else {
                    $ghost.innerHTML = track.title;
                    tracks.push(track);
                }
                console.log({ type: "tracks", item: tracks });
                this.currentDrag = tracks;

                this.$store.dispatch("dnd/update", { type: "tracks", item: tracks });

                e.dataTransfer.setDragImage($ghost, 0, 0);

                EventBus.$emit("dragStart");
            },
            onDragEnd(e) {
                this.isDragging = false;
                this.removeLineIndex();
                EventBus.$emit("dragEnd");
            },
            onDrag(e) {
                if (!this.isDragging) {
                    this.setDomData();
                }
                this.isDragging = true;
            },
            // Tbody
            onDragOver(e) {
                // Recalculate line index
                if (this.currentBox && this.currentBox.type == "PLAYLIST")
                {
                    const rect = this.$refs.tableBody.getBoundingClientRect();
                    const mouseY = e.clientY - rect.top;
                    const index = this.getIndex(mouseY);
                    if (this.index !== index) {
                        this.index = index;
                        this.updateLine();
                    }
                }
                e.preventDefault();
            },
            async onDrop() {
                // Check drag item
                if(!this.currentDrag || this.currentDrag.length == 0) return;
                // Limit move in playlist
                if (!this.currentBox || this.currentBox.type != "PLAYLIST") return;
                // Remove Helper & clean drag state
                this.removeLineIndex();
                this.isDragging = false;

                // Manage Positions
                var minPosition = (this.pagination.page-1) * this.pagination.pageSize;
                let position = (minPosition + this.index);

                // ajdust Position using the current page
                console.log(this.pagination.page, this.pagination.pageSize, "New position : ",position);
                if (this.currentDrag.length == 1)
                {
                    var track = this.currentDrag[0];
                    const oldPosition = track.linkData.position;
                    if (position === oldPosition) {
                        // Don't do anything if we drop on the same place, one single track
                        console.log("Dropping : Don't do anything if we drop on the same place, one single track");
                        return
                    }
                }

                this.isUpdating = true;
                try {
                    //let recordBeforePosition = [...this.currentDrag.filter(itm => itm.linkData.position < position)];
                    //console.log("Records before position",position, recordBeforePosition, recordBeforePosition.length );
                    //position = position - recordBeforePosition.length + 1;
                    if (position> minPosition+ this.pagination.pageSize)
                        position = minPosition + this.pagination.pageSize;
                    console.log("New Position  ",position);
                    var recordUids = this.currentDrag.map(tr => tr.linkData.recordUid);
                    await this.$store.dispatch('Boxes/moveMultipleTrack', {
                        position,
                        recordUids: recordUids,
                        stationUid: this.$store.state.currentStationUid,
                        boxUid: this.currentBox.uid
                    })
                    await this.reloadTracks();
                } catch (e) {
                    console.log('error moving tracks',e)
                }

                //await this.$store.dispatch('Boxes/repositionTracks', {
                //    recordUid: this.currentDrag.linkData.recordUid,
                //    oldPosition,
                //    position
                //})

                this.isUpdating = false;
            },
            updateLine() {
                this.removeLineIndex();
                const $lineIndex = document.createElement('tr');
                $lineIndex.classList.add('line-index');
                const $td = document.createElement('td');
                $td.setAttribute("colspan",10);
                //$td.append(this.index);
                $lineIndex.appendChild($td);
                if (this.index === this.$items.length) {
                    this.$refs.tableBody.appendChild($lineIndex);
                } else {
                    this.$refs.tableBody.insertBefore($lineIndex, this.$items[this.index]);
                }

                this.$lineIndex = $lineIndex;
            },
            removeLineIndex() {
               if(this.$lineIndex && this.$lineIndex.parentElement) {
                   this.$lineIndex.parentElement.removeChild(this.$lineIndex);
                   this.$lineIndex = null;
               }
            },
            setDomData() {
                this.$items = [...this.$refs.tableBody.querySelectorAll('tr:not(.line-index)')];
                this.toggles = [];

                for (let i = 0; i < this.$items.length; i++) {
                    const $item = this.$items[i];
                    const { offsetTop } = $item;
                    this.toggles.push(offsetTop + ($item.offsetHeight / 2) - 40);
                }
            },
            getIndex(mouseY) {
                return this.toggles.filter(item => item < mouseY).length;
            },
            moveFiles(tracks) {
                let files = tracks;

                if (tracks === "selected") {
                    files = Object.keys(this.selectedFiles.tracks).map(
                        prop => this.selectedFiles.tracks[prop]
                    );
                }
                //this.$refs.moveTracks.show(files);
                this.$refs.modalBoxes.show(files);
            },
          similarTracks(tracks) {

            let files = tracks;

            if (tracks === "selected") {
              files = Object.keys(this.selectedFiles.tracks).map(
                  prop => this.selectedFiles.tracks[prop]
              );
            }

            if (files && files.length > 0){
              this.trackUid = files[0].uid;
              console.log(files , this.trackUid)
              console.log(files[0].uid)
              this.$refs.modalSimilarTracks.show(files);
            }
            //this.$refs.moveTracks.show(files);

          },
            async removeFilesFromList(tracks) {
                console.writeLine("RemoveFiles From List")
                //const recordUids = tracks.map(track => track.linkData.recordUid);

                try {
                    // Remove track in API
                    // const response = await HTTP.post(Apis.boxes.unlinkTracks, {
                    //     recordUids,
                    //     stationUid: this.stationUid,
                    //     boxUid: this.currentBox.uid
                    // });


                    // Remove in front
                    // tracks.map(el => {
                    //     const track = this.tracks.filter(item => item.uid === el.uid)[0];
                    //     const index = this.tracks.indexOf(track);
                    //
                    //     this.$delete(this.tracks, index);
                    // });

                    this.removeAllSelectedTracks();
                    await this.reloadTracks();

                    // Reload boxes data
                    await this.$store.dispatch('loadStationBoxes', this.$store.state.currentStationUid);

                } catch (error) {
                    console.log('error ==> ', error);
                    const message = error.response.data.errors[0].message || null;
                }
            },
            handleSettings(e) {
                const trackUid = e.uid;
                const stationUid = this.$route.params.stationUid;
                this.$router.push({
                    name: 'TrackHome',
                    params: {
                        stationUid,
                        trackUid
                    }
                })
            },
            async sortBy(field, sortField = null) {
                this.viewState.isSorting = true
                if (this.sort.field === field) {
                    this.sort.ascending = !this.sort.ascending
                } else {
                    this.sort.field = field
                    this.sort.ascending = true
                }
                this.sort.comparisonKey = sortField
                await this.reloadTracks();
                this.viewState.isSorting = false
            },
            multipleToggle(){
                let multiSelect = {
                    startIndex:Math.min(this.shiftSelection.startIndex, this.shiftSelection.endIndex),
                    endIndex:Math.max(this.shiftSelection.startIndex, this.shiftSelection.endIndex),
                    isSelected:this.shiftSelection.isSelected
                }
                console.log(JSON.stringify(multiSelect))
                let i = 0
                this.tracks.filter(tr => {
                    let elligible = i>= multiSelect.startIndex && i<=multiSelect.endIndex;
                    console.log(i,  elligible)
                    i++;
                    return elligible;
                })
                .map(track =>
                {
                    track.isSelected = this.shiftSelection.isSelected;
                    if(this.currentBox.type === 'PLAYLIST'){
                        if (this.shiftSelection.isSelected) {
                            this.$set(this.selectedFiles.tracks, track.linkData.recordUid, track);
                        } else {
                            this.$delete(this.selectedFiles.tracks, track.linkData.recordUid);
                        }
                    } else {
                        if (this.shiftSelection.isSelected) {
                            this.$set(this.selectedFiles.tracks, track.uid, track);
                        } else {
                            this.$delete(this.selectedFiles.tracks, track.uid);
                        }
                    }
                })
            },
            toggleTrack(track, event, index) {
                track.isSelected = !track.isSelected;
                if (event.shiftKey){
                    if (this.shiftSelection.startIndex != null){
                        this.shiftSelection.endIndex = index;
                        this.multipleToggle()
                        this.shiftSelection = {isSelected:track.true, startIndex:null, endIndex:null}
                        return;
                    }
                    else
                    {
                        this.shiftSelection.isSelected = track.isSelected;
                        this.shiftSelection.startIndex = index;
                        this.shiftSelection.endIndex = null;
                    }
                }
                else{
                    this.shiftSelection = {isSelected:track.true, startIndex:null, endIndex:null}
                    console.log("Set SHIFT Operation", JSON.stringify(this.shiftSelection))
                }

                if(this.currentBox.type === 'PLAYLIST'){
                    if (this.selectedFiles.tracks[track.linkData.recordUid] != null) {
                        this.$delete(this.selectedFiles.tracks, track.linkData.recordUid);
                    } else {
                        this.$set(this.selectedFiles.tracks, track.linkData.recordUid, track);
                    }
                } else {
                    if (this.selectedFiles.tracks[track.uid] != null) {
                        this.$delete(this.selectedFiles.tracks, track.uid);
                    } else {
                        this.$set(this.selectedFiles.tracks, track.uid, track);
                    }
                }
            },
            toggleSelection: function() {
                if (this.selectedFileData.length === 0) {
                    var selection = {};
                    var tracks = this.trackList;
                    if (tracks !== null) {
                        tracks.forEach(tr => {
                            if(this.currentBox.type === 'PLAYLIST')
                                selection[tr.linkData.recordUid] = tr;
                            else
                                selection[tr.uid] = tr;
                        });
                    }
                    this.selectedFiles.tracks = selection;
                } else {
                    this.selectedFiles.tracks = {};
                }
            },
            removeAllSelectedTracks() {
                this.selectedFiles.tracks = {};
            },
            editTracksMeta() {
                const tracks = [];

                Object.keys(this.selectedFiles.tracks).map(item => {
                    tracks.push(this.selectedFiles.tracks[item].uid);
                });

                this.$store.commit("tracks/updateTracks", tracks);
                this.$store.commit("tracks/updatePrevPage", this.$route);
                this.$store.commit("tracks/updateClose", true);

                this.$router.push({
                    name: "TrackHome",
                    params: {
                        stationUid: this.$route.params.stationUid,
                        trackUid: tracks[0]
                    }
                });
            },
            editTracksMix() {
                const tracks = [];

                Object.keys(this.selectedFiles.tracks).map(item => {
                    tracks.push(this.selectedFiles.tracks[item].uid);
                });

                this.$router.push({
                    name: "TrackMix",
                    params: {
                        stationUid: this.$route.params.stationUid,
                        trackUid: tracks[0]
                    },
                    query: {
                        track_ids: JSON.stringify(tracks)
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    table {
        // margin-top: -15px;
        font-weight: 400;
        color: #292C33;

        &.is-dragging {
            td,
            td * {
                pointer-events: none !important;
            }
        }
        tfoot{

            tr td:first-child{
                padding:0;
                a i{
                    color:white;
                }
            }
            tr td{
                position: sticky;
                bottom: 0;
                z-index:1000;
            }
        }
    }

    thead,
    thead tr:nth-child(1) th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        // top: -15px; /* Page content padding correction */
        background: white;
        z-index: 1;
    }

    /* thead, */
    thead tr:nth-child(1) th {
        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: #d2d2d2;
        }
    }

    td,
    th {
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;

        &.td-s {
            min-width: 70px;
        }
    }

    td {
        white-space: nowrap;
        text-overflow:ellipsis;
        &:not(:last-child) {
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 10px;
        }

        &:first-child {
            padding-left: 8px;
            padding-right: 12px;
        }

        span {
            white-space: nowrap;

            .decorator {
                margin-right: 10px;
            }
        }

        button {
            //background: none;
            border: 0;

            &::after {
                content: none;
            }

            i {
                transition: color .2s ease-in-out;
                font-size: 18px;
            }
        }
    }

    th {
        color: #AAAAAA;
        padding: 12px 15px 12px 0;

        &:first-child {
            padding-right: 12px;
        }
    }




    tbody tr {
        &.shiftable{
           border-color:var(--COLOR_BRAND)
        }
        color: #292C33;
        font-size: 13px;
        line-height: 16px;
        border-bottom: 1px solid #D2D2D2;
    }
    div.menu-expanded{
      .table-footer{
        left: 300px;
        transition: all .5s ease-in-out;
      }
    }
    .table-footer {
      position: sticky;
      height: 45px;
      left: 10px;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      z-index: 1200;
      right: 10px;
      align-items: center;
      transition: all .5s ease-in-out;
      .td {
        flex-shrink: 0;
        padding: 16px 12px;
        vertical-align: middle;
        color: #fff;
        &:first-child {
          padding-left: 15px;
        }
        &:last-child {
          display: flex;
          min-width: 142px;
          padding-left: 22px;
          a + a {
            margin-left: 20px;
          }
        }
        button.option {
          color: #fff;
        }
      }
      .fas {
        &.fas-l {
          font-size: 18px;
        }
        &.fas-xl {
          font-size: 24px;
        }
      }
    }

    .table-footer-left,
    .table-footer-right {
      display: flex;
      align-items: center;
      padding: 20px 15px;
      color: #fff;
      .fas {
        display: block;
      }
    }

    .table-footer-right {
      .table-footer-button {
        margin-left: 20px;
      }
    }

    .table-footer-text {
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;
    }

    .table-footer-count {
      display: inline-block;
      padding: 2px 10px 4px;
      margin-right: 4px;
      border-radius: 20px;
      background-color: rgba(#000, 0.2);
    }

    .table-footer-button {
      display: inline-block;
      transition: opacity 0.2s ease-in-out;
      color: #fff;
      text-decoration: none;
      cursor: pointer;
      vertical-align: middle;
      &:hover {
        opacity: 0.6;
      }
      + .table-footer-text {
        margin-left: 23px;
      }
    }

    .description{
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100px;
    }
    th:last-child,
    td:last-child {
      background: white;
      right: 0;
      position: sticky;
      z-index:1000;
      vertical-align: middle;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background-color: #d2d2d2;
      }
    }


    </style>

<style lang="scss" >
    .pointer-events-none {
      pointer-events: none;
    }
    .cursor-not-allowed {
      cursor : not-allowed!important;
    }
    .track-table {
        min-width: 100%;
        .btn.dropdown-toggle {
            border: 0;
            background: none;

            &::after {
                content: none;
            }
        }

        &.is-sorting {
            tbody {
                opacity: 0.5;
                pointer-events: none;
            }
        }
    }
    //td:last-child {
    //  background: white !important;
    //  z-index: 1000;
    //}


    .line-index{
        //border: 1px dashed black;
        box-shadow: -1px 1px 15px var(--COLOR_BRAND);
        border-top: 2px solid var(--COLOR_BRAND_TRANSPARENT);
        //td{
        //    box-shadow: -1px 1px 15px var(--COLOR_BRAND);
        //    border-top: 2px solid var(--COLOR_BRAND_TRANSPARENT);
        //}
    }

    .sort {
      display: flex;
      cursor: pointer;
      transition: color 0.15s ease-in-out;
      color: #aaaaaa;
      font-weight: 400;

      &[disabled] {
        pointer-events: none;
      }

      &.is-active {
        color: #000;
      }

      &:hover {
        text-decoration: none;
      }

      &-icons {
        display: flex;
        flex-direction: column;
        position: relative;
        margin-left: 5px;

        i {
          font-size: 10px;
          height: 8px;
        }
      }

      @keyframes sorting {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      .fa-sync-alt {
        align-self: center;
        font-size: 12px;
        margin-left: 5px;
        transform-origin: 50% 50%;
        animation: sorting 1s linear infinite;
      }
    }
    .pagination__root{
        position: fixed;
        bottom: 70px;
        left: 50%;
        transform: translateX(0);
        border-radius: 0.25rem;
        max-width: unset;
    }
    .b-pagination li {
        padding: 0;
        box-shadow: 0 1px 4px rgba(0,0,0,.3);
        border-radius: 3px;
        a{
            //border-top: none;
            //border-bottom: none;
        }
        a, span{
            height: 100%;
        }
        &.active {
            a.page-link{
                border-color: #dee2e6;
            }
        }
    }

    /*.full{*/
    /*    height: 100%;*/
    /*}*/
    .tag{
      padding:5px;border-radius: 7px ;margin-right: 3px
    }
</style>
